import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Cómo funciona',
    href: '#como-funciona'
  }, {
    name: 'Casos de éxito',
    href: '#casos-de-exito'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'shadow-md py-3' : 'py-5'}`} data-id="element-126">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <div className="flex justify-between items-center" data-id="element-128">
          {/* Logo */}
          <a href="#" className="flex-shrink-0" data-id="element-129">
            <img src="https://cdn.magicpatterns.com/uploads/6GE52Wm2byR8iyJxyLfsC1/Logo_LOKL_MKT.png" alt="LOKL MKT - Más clientes. Menos complicaciones." className="h-16 sm:h-20 w-auto object-contain" data-id="element-130" />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-131">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-600 hover:text-primary font-medium transition-colors" data-id="element-132">
                {link.name}
              </a>)}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block" data-id="element-133">
            <a href="#contacto" className="inline-flex items-center justify-center px-6 py-3 bg-accent text-white font-medium rounded-xl hover:bg-[#e55a1f] transition-colors shadow-sm hover:shadow-md" data-id="element-134">
              Empieza a Crecer &rarr;
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-gray-600 hover:text-primary transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-135">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-136" /> : <MenuIcon className="w-6 h-6" data-id="element-137" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg py-4 px-4 flex flex-col gap-4" data-id="element-138">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-600 hover:text-primary font-medium py-2 transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-139">
              {link.name}
            </a>)}
          <a href="#contacto" className="inline-flex items-center justify-center px-6 py-3 bg-accent text-white font-medium rounded-xl mt-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-140">
            Empieza a Crecer &rarr;
          </a>
        </div>}
    </header>;
}